<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">Book Now</div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <div>ID: {{ section.id }}</div>
      <div>Type: {{ section.type }}</div>
      <div>Sort Order: {{ section.sort_order }}</div>
    </v-card-subtitle>
    <v-card-text v-if="expand">
      <div class="d-flex flex-wrap">
        <v-flex xs12 class="mt-2 mb-2">
          <v-text-field label="Title" v-model="section.title" dense></v-text-field>
        </v-flex>
        <v-flex xs12 class="mt-2 mb-2">
          <v-text-field label="Subtitle" v-model="section.subtitle" dense></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="CTA Text" v-model="section.attributes.cta_text" dense></v-text-field>
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions v-if="expand">
      <v-btn color="primary" @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import homefeedService from '../../../services/homefeed';
export default Vue.extend({
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    expand: false,
  }),
  methods: {
    async save() {
      const requestBody = {
        title: this.section.title,
        subtitle: this.section.subtitle,
        attributes: { cta_text: this.section.attributes.cta_text },
      };

      await homefeedService.updateSection(this.section.id, requestBody);
      console.log('Successfully updated section ID:', this.section.id);
    },
  },
});
</script>

<style scoped></style>
